import React, { useState, useCallback, useEffect } from 'react'
import { Spinner, Modal } from '@shopify/polaris'
import { useSelector, useDispatch } from 'react-redux'
import 'Styles/timeline.css'
import Timeline from 'rsuite/Timeline'
import styles from 'Styles/BookingTimeline.scss'
import moment from 'moment'
import i18n from '../../translations/i18n'

function OrderSchedule({ showModal, setShowModal, schedule }) {
  const { t } = i18n
  const [items, setItems] = useState([])
  const formatItems = (list) => {
    return list?.map((l, i) => {
      let date = moment(l.billing_date).format('MMM Do YYYY, h:mm:ss a')
      return (
        <Timeline.Item key={i}>
          <h3 className={styles.timelineHeader}>
            #{i + 1} {date}
          </h3>
        </Timeline.Item>
      )
    })
  }

  return (
    // <Modal
    //   open={showModal}
    //   onClose={() => {
    //     setShowModal(false)
    //   }}
    //   title={t('order-schedule')}
    //   primaryAction={{
    //     content: t('close'),
    //     onAction: () => {
    //       setShowModal(false)
    //     },
    //   }}
    //   size="large"
    // >
    //   <Modal.Section>
    <div style={{ color: '#202223' }}>
      <Timeline>{formatItems(schedule)}</Timeline>
    </div>
    //   </Modal.Section>
    // </Modal>
  )
}
export default OrderSchedule
